export default "__VITE_ASSET__5jlRtBlZ__"